var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.414,
    height: 19.414
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search_svg__a{fill:none;stroke:#a7abb2;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "search_svg__a",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "search_svg__a",
    d: "M20 20l-4.35-4.35"
  }))));
}
export default __webpack_public_path__ + "static/media/search.803cbd4b.svg";
export { SvgSearch as ReactComponent };